export const formatDate = (
  date: Date,
  format?: {
    year?: "numeric" | "2-digit"
    month?: "numeric" | "2-digit" | "long" | "short" | "narrow"
    day?: "numeric" | "2-digit"
  }
): string => {
  // Extract the date components

  const formattedYear = date.getFullYear()
  const formattedMonth = String(date.getMonth() + 1).padStart(2, "0")
  const formattedDay = String(date.getDate()).padStart(2, "0")

  // Return the formatted date
  if (format) {
    return date.toLocaleDateString("en-AE", format)
  }
  // Ex Output: "20230513"
  return formattedYear + formattedMonth + formattedDay
}

export const subtractDays = (date: Date, days: number): Date => {
  const result = new Date(date)
  result.setDate(result.getDate() - days)
  return result
}

export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export const convertDateFormat = (
  dateString: string,
  targetFormat: {
    year?: "numeric" | "2-digit"
    month?: "numeric" | "2-digit" | "long" | "short" | "narrow"
    day?: "numeric" | "2-digit"
  }
): string => {
  let currentDate: Date
  const datePattern = /^\d{4}-\d{2}-\d{2}$/

  if (datePattern.test(dateString)) {
    // Check if the date string is in yyyy-mm-dd format
    currentDate = new Date(`${dateString}`)
  } else {
    // Else the date string is in yyyymmdd format
    const year = dateString.substring(0, 4)
    const month = dateString.substring(4, 6)
    const day = dateString.substring(6, 8)
    currentDate = new Date(`${year}-${month}-${day}`)
  }
  // Check if the current date is valid
  if (isNaN(currentDate.getTime())) {
    throw new Error("Invalid date string")
  }

  return currentDate.toLocaleDateString("en-AE", targetFormat)
}

export const addBusinessDays = ({
  numDays,
  holidays = [
    new Date("2023-06-27"), // Arafah
    new Date("2023-06-28"), // Eid Al Adha
    new Date("2023-06-29"), // Eid Al Adha
    new Date("2023-06-30"), // Eid Al Adha
    new Date("2023-07-19"), // Islamic New Year
    new Date("2023-09-27"), // Prophet's Birthday
    new Date("2023-12-01"), // Commemoration Day
  ],
  startDate,
}: {
  numDays: number
  holidays?: Date[]
  startDate?: Date
}): Date => {
  const weekendDays = [0] // Sunday (0)

  const currentDate = startDate ? new Date(startDate) : new Date()
  let count = 0

  while (count < numDays) {
    currentDate.setDate(currentDate.getDate() + 1)

    if (
      !weekendDays.includes(currentDate.getDay()) &&
      !holidays.some((holiday) => isSameDay(holiday, currentDate))
    ) {
      count++
    }
  }

  return currentDate
}

function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}
